import ButtonContainer from "@components/ButtonContainer";
import TextEditorTwo from "@components/EasyDev/text-editor/TextEditor";
import FileUpload from "@components/Shared/FileUpload";
import FormDatePickerField from "@components/Shared/FormDatePickerField";
import FormTextareaField from "@components/Shared/FormTextareaField";
import FormTextField from "@components/Shared/FormTextField";
import { timestampToDate } from "@helpers/dates.format";
import { INews } from "@interfaces/news";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement, useState } from "react";
import { Field } from "react-final-form";

interface IModifyForm extends IFormProps {
  data: INews;
}

const ModifyForm = ({ handleSubmit, data }: IModifyForm): ReactElement => {
  const [date] = useState(timestampToDate(data?.date));

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">Title</span>
        <div className="form__form-group-field">
          <Field
            name="title"
            component={FormTextField}
            type="text"
            placeholder={"Enter a Title"}
            isAboveError
            initialValue={data?.title}
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Date</span>
        <div className="form__form-group-field">
          <Field
            name="date"
            component={FormDatePickerField}
            placeholder="Enter a Date"
            isAboveError
            initialValue={date}
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Summary</span>
        <div className="form__form-group-field">
          <Field
            name="summary"
            component={FormTextareaField}
            type="text"
            placeholder={"Enter a Summary"}
            isAboveError
            initialValue={data?.summary}
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Body</span>
        <div className="form__form-group-field">
          <Field
            name="body"
            component={TextEditorTwo}
            isAboveError
            initialValue={data?.body}
          />
        </div>
      </div>

      <FileUpload
        title="Image"
        isSingle
        initialData={data}
        formFieldName="imageUrl"
      />

      <ButtonContainer />
    </form>
  );
};

export default ModifyForm;
